import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import clsx from "clsx";
import styles from "./SimpleButton.module.scss";
export default function SimpleButton(_a) {
    var { disabled = false, children } = _a, props = __rest(_a, ["disabled", "children"]);
    return (_jsx("div", Object.assign({}, props, { onClick: e => !disabled && props.onClick && props.onClick(e), className: clsx(styles.simpleButton, props.className), children: children })));
}
